import React from 'react';
import { Alert, Box, Button, Chip, Paper, Stack, Typography } from '@mui/material';
import MockDemoTerminal from '../components/MockDemoTerminal';
import Seo from '../components/Seo';


const DemoLessonPage = () => {
    return (
        <Box sx={{ display: 'grid', gap: 3 }}>
            <Seo
                title="Try a Free Linux Demo Lesson"
                description="Try a short, browser-based Linux shell lesson before creating a NixDojo account."
                path="/demo"
            />

            <Paper variant="outlined" sx={{ p: { xs: 3, md: 4 } }}>
                <Stack spacing={2}>
                    <Chip label="No account required" color="secondary" variant="outlined" sx={{ width: 'fit-content' }} />
                    <Typography variant="h2">Try a guided Linux shell demo.</Typography>
                    <Typography color="text.secondary" sx={{ maxWidth: 900 }}>
                        This mock terminal runs entirely in the browser and only accepts the exact curated commands in this lesson. No backend shell, container, pod, or server terminal is exposed to public users.
                    </Typography>
                    <Alert severity="warning" variant="outlined">
                        Commands outside the curated task list are blocked in the browser. Do not paste secrets, passwords, API keys, or personal data into this demo.
                    </Alert>
                </Stack>
            </Paper>

            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', lg: '0.8fr 1.2fr' }, gap: 3 }}>
                <Paper variant="outlined" sx={{ p: 3 }}>
                    <Typography variant="h4" sx={{ mb: 2 }}>Lesson: curated shell tasks</Typography>
                    <Stack spacing={2}>
                        <Box>
                            <Typography variant="h6">1. See where you are</Typography>
                            <Typography component="code">pwd</Typography>
                        </Box>
                        <Box>
                            <Typography variant="h6">2. List files</Typography>
                            <Typography component="code">ls -la</Typography>
                        </Box>
                        <Box>
                            <Typography variant="h6">3. Confirm the demo user</Typography>
                            <Typography component="code">whoami</Typography>
                        </Box>
                        <Box>
                            <Typography variant="h6">4. Create and inspect a note</Typography>
                            <Typography component="pre" sx={{ whiteSpace: 'pre-wrap', m: 0 }}>{'echo "hello nixdojo" > note.txt\ncat note.txt'}</Typography>
                        </Box>
                        <Box>
                            <Typography variant="h6">5. Clean up</Typography>
                            <Typography component="code">rm note.txt</Typography>
                        </Box>
                    </Stack>
                    <Button href="/login" variant="contained" size="large" sx={{ mt: 3 }}>
                        Create an account for full labs
                    </Button>
                </Paper>

                <Box aria-label="Demo terminal">
                    <MockDemoTerminal />
                </Box>
            </Box>
        </Box>
    );
};

export default DemoLessonPage;
